<template>
	<div class="mb-6">
		<Card :borderLeftColor="0" class="flex-row justify-between border-card">
			<template v-slot:center>
				<div class="hidden sm:flex flex-col justify-start items-start py-4 pl-2">
          <DoiText :textColor="1" :fontFamily="1" :fontSize="5" :fontWeight="6" class="uppercase">{{payment.reservation.sport}}</DoiText>
					<div class="flex flex-col sm:flex-row mt-2">
						<DoiText :fontFamily="0" :textColor="1" :fontSize="3">{{reservationDate()}} à {{reservationHour()}}</DoiText>
            <div class="flex items-center">
              <DoiText type="span" class="sm:mx-1 mr-2 w-3 h-3 block bg-red" />
              <DoiText :fontFamily="1" :textColor="1" :fontSize="3">{{payment.reservation.fitArena}}</DoiText>
            </div>
					</div>
				</div>
				<div class="flex flex-col sm:hidden justify-start items-start py-4 pl-2">
          <DoiText :textColor="1" :fontFamily="1" :fontSize="3" :fontWeight="6" class="uppercase">{{payment.reservation.sport}}</DoiText>
					<div class="flex flex-col sm:flex-row mt-2">
						<DoiText :fontFamily="0" :textColor="1" :fontSize="3">{{reservationDate()}} à</DoiText>
						<DoiText :fontFamily="0" :textColor="1" :fontSize="3">{{reservationHour()}}</DoiText>
            <div class="flex items-center">
              <DoiText type="span" class="sm:mx-1 mr-2 w-3 h-3 block bg-red" />
              <DoiText :fontFamily="1" :textColor="1" :fontSize="3">{{payment.reservation.fitArena}}</DoiText>
            </div>
					</div>
				</div>
			</template>
			<template v-slot:right>
				<div class="hidden sm:flex flex-col items-end justify-end pr-2 pb-4">
          <DoiText :textColor="1" :fontSize="3" :fontFamily="6" class="sm:text-xl">{{formatPrice}}</DoiText>
          <DoiText :fontFamily="0" :textColor="1" :fontSize="3" class="md:hidden">{{formatDate(payment.datePaiement)}}</DoiText>
          <div class="flex items-center">
            <DoiText :fontFamily="0" :textColor="1" :fontSize="3" class="hidden md:block">{{formatDate(payment.datePaiement)}}</DoiText>
            <DoiText type="span" class="hidden md:block mx-1 w-3 h-3 block bg-red" />
            <DoiText :textColor="1" :fontSize="2" :fontFamily="5" class="uppercase sm:text-lg">{{payment.statut}}</DoiText>
            <DoiText type="span" class="md:hidden ml-1 w-3 h-3 block bg-red" />
          </div>
				</div>
				<div class="flex flex-col sm:hidden items-end justify-center pr-2 pb-4">
          <DoiText :textColor="1" :fontSize="3" :fontFamily="6" class="text-s">{{formatPrice}}</DoiText>
          <DoiText :fontFamily="0" :textColor="1" :fontSize="3">{{formatDate(payment.datePaiement).split(',')[0]}},</DoiText>
          <DoiText :fontFamily="0" :textColor="1" :fontSize="3">{{formatDate(payment.datePaiement).split(',')[1]}}</DoiText>
          <div class="flex items-center">
            <DoiText type="span" class="hidden md:block mx-1 w-3 h-3 block bg-red" />
            <DoiText :textColor="1" :fontSize="2" :fontFamily="5" class="uppercase sm:text-lg">{{payment.statut}}</DoiText>
            <DoiText type="span" class="md:hidden ml-1 w-3 h-3 block bg-red" />
          </div>
				</div>
			</template>
		</Card>
	</div>
</template>

<script>
import dayjs from 'dayjs'
import Card from '@/components/atomic/Card'

export default {
  name: 'PaymentHistoryListItem',
  components: { Card },
  props: {
    isOdd: {
      type: Boolean,
      default: false
    },
    payment: {
      type: Object
    }
  },
  computed: {
    formatPrice () {
      return Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(this.payment.montant / 100)
    }
  },
  methods: {
    formatDate (datePaiement) {
      const month = dayjs(datePaiement).format('MM')
      let hour = dayjs(datePaiement).format('HH')
      if (month >= '04' && month <= '10') {
        hour = hour - 2
      } else {
        hour = hour - 1
      }
      const date = dayjs(datePaiement).format('DD-MM-YYYY, ' + hour + '[h]mm')
      return date
    },
    reservationDate () {
      const date = dayjs(this.payment.reservation.dateReservation).format('DD-MM-YYYY')
      return date
    },
    reservationHour () {
      const month = dayjs(this.payment.reservation.dateReservation).format('MM')
      let hour = dayjs(this.payment.reservation.dateReservation).format('HH')
      if (month >= '04' && month <= '10') {
        hour = hour - 2
      } else {
        hour = hour - 1
      }
      const fullHour = dayjs(this.payment.reservation.dateReservation).format(hour + '[h]mm')
      return fullHour
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/_variables";

.border-card {
  border-radius: 4px;
}

.bg-red {
  background-color: $doi--color-color0;
}

@media (max-width: 640px) {
  .intitule {
    font-size: 1rem;
  }
}
</style>
